import React, { PropsWithChildren } from 'react';

import { css } from '@emotion/css';
import { Flex } from '@opendoor/bricks/core';
import { useDevice } from '@opendoor/bricks/hooks/useMedia';
import { BREAKPOINTS_DICT } from '@opendoor/bricks/theme/eero/foundations/breakpoints';

const styles = {
  dashboard_padding: css`
    padding: 25px 0px 50px 0px;
  `,
};

// storybook-check-ignore
export const ParnDashboardLayout: React.FC<PropsWithChildren> = ({ children }) => {
  return <ParnDashboardLayoutContent>{children}</ParnDashboardLayoutContent>;
};

const ParnDashboardLayoutContent: React.FC<PropsWithChildren> = ({ children }) => {
  const { isMobile } = useDevice();
  return (
    <div className={styles.dashboard_padding}>
      <Flex
        data-testid="parn-dashboard-layout-content"
        flexDirection="column"
        mx="auto"
        gridGap="4"
        maxWidth={BREAKPOINTS_DICT.LG}
        padding={isMobile ? '0 24px 0 24px' : '0 60px 0 60px'}
      >
        {children}
      </Flex>
    </div>
  );
};
